export const PROGRESS_BAR_BOTTOM = 0
export const PROGRESS_BAR_TOP = 1
